/**
 * @generated SignedSource<<342826eb009679ddb4fcf92bebe04efc>>
 * @relayHash 2ad350c3737d730c5743e50cb46f19c2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 02feb19f38be1ab128b02c5c399d8ab586a2d0e12a185e37d9905a9070d8f212

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useCreateFlowMutation$variables = {
  additionalInfoJSON: string;
  cloudId: string;
  createdBy: string;
  issueARI?: string | null | undefined;
  jiraHost: string;
  jiraIssueJSON?: string | null | undefined;
  repoUrl: AGG$URL;
};
export type useCreateFlowMutation$data = {
  readonly devai_createFlow: {
    readonly data: {
      readonly id: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useCreateFlowMutation = {
  response: useCreateFlowMutation$data;
  variables: useCreateFlowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "additionalInfoJSON"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdBy"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueARI"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraHost"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraIssueJSON"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "repoUrl"
},
v7 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "additionalInfoJSON",
        "variableName": "additionalInfoJSON"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "createdBy",
        "variableName": "createdBy"
      },
      {
        "kind": "Variable",
        "name": "issueARI",
        "variableName": "issueARI"
      },
      {
        "kind": "Variable",
        "name": "jiraHost",
        "variableName": "jiraHost"
      },
      {
        "kind": "Variable",
        "name": "jiraIssueJSON",
        "variableName": "jiraIssueJSON"
      },
      {
        "kind": "Variable",
        "name": "repoUrl",
        "variableName": "repoUrl"
      }
    ],
    "concreteType": "DevAiFlowSessionCreatePayload",
    "kind": "LinkedField",
    "name": "devai_createFlow",
    "plural": false,
    "selections": [
      {
        "concreteType": "DevAiFlowSession",
        "kind": "LinkedField",
        "name": "data",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useCreateFlowMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCreateFlowMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "id": "02feb19f38be1ab128b02c5c399d8ab586a2d0e12a185e37d9905a9070d8f212",
    "metadata": {},
    "name": "useCreateFlowMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "84b8e9172a6686e5902ac378cbec46de";

export default node;
